var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Emitter } from "pixi-particles";
import { configParticlesChimneySmoke } from "../features/animation/particles/configParticlesChimneySmoke";
import { configParticlesChimneySmokeOverrides } from "../features/animation/particles/configParticlesChimneySmokeOverrides";
import { utilAnimation } from "../utils/animation/utilAnimation";
var ParticleContainer = PIXI.particles.ParticleContainer;
var BF2ChimneySmokeParticleAnim = /** @class */ (function () {
    function BF2ChimneySmokeParticleAnim() {
        var _this = this;
        this.animDurationMaxTime = 40000;
        this.animDurationMinTime = 20000;
        this.particleImage = PIXI.Texture.fromImage(require("../assets/particles/smoke_particles.png"));
        this.configForBuilding = __assign({}, configParticlesChimneySmoke);
        this.particleContainer = new ParticleContainer();
        this.removeInterval = function () {
            clearInterval(_this.intervalTimeOut);
        };
        this.startAnimation = function (container, buildingName) {
            _this.container = container;
            _this.buildingName = buildingName;
            _this.particleContainer.position.set(configParticlesChimneySmokeOverrides[buildingName].x, configParticlesChimneySmokeOverrides[buildingName].y);
            var intervalTimeGen = function () {
                return Math.floor(Math.random() * (_this.animDurationMaxTime - _this.animDurationMinTime) +
                    _this.animDurationMinTime);
            };
            _this.intervalTimeOut = setTimeout(function () {
                var emitter = new Emitter(_this.particleContainer, _this.particleImage, _this.configForBuilding);
                _this.container.addChild(_this.particleContainer);
                utilAnimation.startParticleAnimation(emitter, true);
                _this.animStartTimeout = setTimeout(function () {
                    _this.removeAnimation(emitter);
                }, _this.animDurationMinTime);
            }, intervalTimeGen());
        };
        this.removeAnimation = function (emitter) {
            utilAnimation.destroyParticleAnimation(emitter);
            _this.container.removeChild(_this.particleContainer);
            clearTimeout(_this.animStartTimeout);
            _this.removeInterval();
            _this.startAnimation(_this.container, _this.buildingName);
        };
        this.removeInterval();
    }
    return BF2ChimneySmokeParticleAnim;
}());
export { BF2ChimneySmokeParticleAnim };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/BF2ChimneySmokeParticleAnim.ts
// module id = 2191
// module chunks = 3